var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"d-inline-flex pa-2",attrs:{"outlined":"","tile":""}},[_c('div',[_vm._v("I'm an inline flexbox container!")])])}
var staticRenderFns = []

export { render, staticRenderFns }